/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const getViewportWidth = () => {
    return window.innerWidth || document.documentElement.clientWidth;
}

export class Backdrop {
    constructor(onClick) {
        this.element = null;
        this.onClick = onClick;
    }

    show() {
        if (this.element) return;
        
        this.element = document.createElement('div');
        this.element.className = 'nav-backdrop';
        this.element.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.65);
            z-index: 10;
            opacity: 0;
            transition: opacity 0.3s ease;
        `;
        
        document.body.appendChild(this.element);
        
        // Trigger fade-in
        setTimeout(() => {
            if (this.element) this.element.style.opacity = '1';
        }, 10);
        
        if (this.onClick) {
            this.element.addEventListener('click', this.onClick);
        }
    }

    hide() {
        if (!this.element) return;
        
        this.element.style.opacity = '0';
        
        setTimeout(() => {
            if (this.element) {
                this.element.remove();
                this.element = null;
            }
        }, 300);
    }
}

export const createOverlayBG = (id) => {
    if (!document.querySelector('__msg_overlay')) {
        $('<div id="' + id + '" class="__msg_overlay">').css({
            "width": "100%",
            "height": "100%",
            "background": "#000",
            "position": "fixed",
            "top": "0",
            "left": "0",
            "zIndex": "50",
            "MsFilter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=60)",
            "filter": "alpha(opacity=60)",
            "MozOpacity": 0.6,
            "KhtmlOpacity": 0.6,
            "opacity": 0.6
        }).appendTo($('.inner-content'));
    }
}

export const removeOverlayBG = () => {
    $(".__msg_overlay").remove();
}

export const handleMenuResize = () => {
    $(window).on("resize", function () {
        const viewportWidth = getViewportWidth();
        const $body = $("body");
        const isOpen = $body.hasClass("nav-open");
        const $trigger = $(".navbar-toggler");
        if (viewportWidth > 992 && isOpen) {
            $trigger.trigger("click");
        }
    });
}

const removeOverlayBGById = (id) => {
    const overlay = document.getElementById(id);
    if (overlay) {
        overlay.remove();
    }
}

const throttle = (func, limit) => {
    let inThrottle;
    return function() {
        const args = arguments;
        if (!inThrottle) {
            func.apply(this, args);
            inThrottle = true;
            setTimeout(() => inThrottle = false, limit);
        }
    }
}

 export const setBodyScrollClass = () => { 

    const header = document.querySelector(".page-header-container");
    const homeNav = document.querySelector(".home-nav");

    if (!header) return;

    const header_scroll_threshhold = 0.5;
    const home_nav_threshold = 0.8;

    const adjustHeader = () => {
        const header_height = header.offsetHeight;
        const scrollpos = window.scrollY;
        if (scrollpos >= header_height * header_scroll_threshhold) { 
            add_class_on_scroll(header);
        } else { 
            remove_class_on_scroll(header);
        }
        if (homeNav) {
            if (scrollpos >= header_height * home_nav_threshold) { 
                homeNav?.classList.add("fade-out");
            } else { 
                homeNav?.classList.remove("fade-out");
            }
        }
    }
    window.addEventListener('scroll', throttle(adjustHeader, 16));
    adjustHeader();
}

    const add_class_on_scroll = (header) => header.classList.add("scrolling");
    const remove_class_on_scroll = (header) => header.classList.remove("scrolling");

export const normalizeTargets = (
  target,
  filterTypes
) => {
  let elements = [];

  if (typeof target === 'string') {
    elements = Array.from(document.querySelectorAll(target));
  } else if (target instanceof HTMLElement) {
    elements = [target];
  } else if (target instanceof NodeList) {
    elements = Array.from(target);
  } else if (Array.isArray(target)) {
    elements = target;
  }
  
  // Apply filter if provided
  if (filterTypes && filterTypes.length > 0) {
    return elements.filter(el => 
      filterTypes.some(type => el instanceof type)
    );
  }
  
  return elements;
};